<template>
  <div class="Comparison">
    <div class="title row-center" style="justify-content:  space-between;">
      <div class="row-center">
        <el-date-picker
          :editable="false"
          :picker-options="pickerOptions"
          :clearable="false"
          class="dateSelect"
          v-model="date"
          :format="radio === 'week' ? 'yyyy 第 WW 周' : ''"
          :type="radio === 'day' ? 'date' : radio"
          :placeholder="new Date().toLocaleDateString().replace(/\//g, '-')"
        >
        </el-date-picker>

        <div class="radio">
          <el-radio v-model="radio" label="year">年</el-radio>
          <el-radio v-model="radio" label="month">月</el-radio>
          <el-radio v-model="radio" label="week">周</el-radio>
          <el-radio v-model="radio" label="day">日</el-radio>
        </div>
        <el-button plain class="btn per" @click="perD" v-if="radio === 'day'"
          >上一日</el-button
        >
        <el-button plain class="btn per" @click="perM" v-if="radio === 'month'"
          >上一月</el-button
        >
        <el-button plain class="btn per" @click="perW" v-if="radio === 'week'"
          >上一周</el-button
        >
        <el-button plain class="btn per" @click="perY" v-if="radio === 'year'"
          >上一年</el-button
        >
        <el-button
          class="btn next"
          plain
          @click="nextD"
          v-if="radio === 'day'"
          :disabled="nextDayDisabled"
          >下一日
        </el-button>
        <el-button
          class="btn next"
          plain
          @click="nextM"
          v-if="radio === 'month'"
          :disabled="nextDayDisabled"
        >
          下一月
        </el-button>
        <el-button
          class="btn next"
          plain
          @click="nextW"
          v-if="radio === 'week'"
          :disabled="nextDayDisabled"
        >
          下一周
        </el-button>
        <el-button
          class="btn next"
          plain
          @click="nextY"
          v-if="radio === 'year'"
          :disabled="nextDayDisabled"
          >下一年
        </el-button>
      </div>
      <div class="right">
        <div class="area" @click.stop="listShow = !listShow">
          区域一：{{ currentLoop.name
          }}<img src="../../../assets/img/change0.png" alt="" />
        </div>
      </div>
    </div>
    <div class="cont">
      <div class="box">
        <div class="tt">
          能耗结构变化趋势<el-checkbox v-model="showMax" style="float:right"
            >最值分析</el-checkbox
          >
        </div>
        <div
          class="echarts row-center"
          style="justify-content: space-between"
          :class="{ showMax }"
        >
          <!-- <div class="left" style="height:32vh">
            <charts id="Comparison" :option="Comparison"></charts>
          </div> -->
            <div class="left" style="height:30vh;text-align: center;">
              <Curve
                v-if="diagramData && canvasShow"
                :chartsData="diagramData"
              ></Curve>
              <img
                class="nodata"
                v-else
                src="../../../assets/img/not_found_data.png"
                alt=""
              />
            </div>
          <div
            v-show="showMax"
            class="max-right row-center"
            style="justify-content: space-between"
            v-if="canvasShow"
          >
            <div
              class="row-max row-center"
              style="justify-content: space-between"
              v-for="(item, index) in diagramData.legend.data"
              :key="index"
            >
              <div class="max-name row-center">{{ item }}</div>
              <div
                class="details column-center"
                style="justify-content: space-evenly"
              >
                <div
                  class="row-center"
                  style="width: 100%; justify-content: flex-start"
                >
                  <span>最大值</span><span>{{ max(item) }}</span
                  ><span></span>
                </div>
                <div
                  class="row-center"
                  style="width: 100%; justify-content: flex-start"
                >
                  <span>最小值</span><span>{{ min(item) }}</span
                  ><span></span>
                </div>
                <div
                  class="row-center"
                  style="width: 100%; justify-content: flex-start"
                >
                  <span>平均值</span><span>{{ average(item) }}</span
                  ><span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="box row-center"
        style="flex-flow: row column;justify-content: space-between; background: none;padding:0"
      >
        <div class="item">
          <div class="top">分类能耗占比</div>
          <div style="height:28vh">
            <charts id="Classification1" :option="Classification1"  v-loading="Classificationloading1"></charts>
          </div>
        </div>
        <div class="item">
          <div class="top">分项能耗占比</div>
          <div style="height:28vh">
            <charts id="Classification2" :option="Classification2" v-loading="Classificationloading2"></charts>
          </div>
        </div>
        <div class="item">
          <div class="top">分类能耗结构</div>
          <div style="height:28vh">
            <charts id="Classification3" :option="Classification3" v-loading="Classificationloading3"></charts>
          </div>
        </div>
        <div class="item">
          <div class="top">分项能耗结构</div>
          <div style="height:28vh">
            <charts id="Classification4" :option="Classification4" v-loading="Classificationloading4"></charts>
          </div>
        </div>
      </div>
    </div>

    <div @click.stop="" ref="area">
      <Zone
        v-if="listShow"
        @closedArea="closedArea"
        :currentLoop="currentLoop"
        @getcurrentLoop="getcurrentLoop"
      ></Zone>
    </div>
  </div>
</template>

<script>
import charts from "../../../components/Energy/charts";
import Zone from "../../../components/Energy/Zone.vue";
import { classifiedEnergyConsumptionCoal,BuildingItemEnergy,BuildingConsumption  } from "../../../api/power";
import { treeBuilding } from "../../../api/common";
import { floatFormat } from "../../../util/MathUtil";
import {
  perDay,
  perMonth,
  perYear,
  nextDay,
  nextMonth,
  nextYear,
  dateFormat,
  addDay,
  getAppointedDate,
  weekStart,
  weekEnd,
  getDiffDate,
} from "../../../util/DateUtil";
import Curve from "../../../chart/Curve";
export default {
  components: {
    charts,
    Zone,
    Curve
  },
  data() {
    return {
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      date: new Date(),
      radio: "day",
      Comparison1: {},
      isActive: -1,
      listShow: false,
      currentLoop: {},
      loading: false,
      showMax: false,
      canvasShow:false,
      diagramData: null,
      ClassData: [],
      ClassData1:{
        powerSC:0,
        heatSC:0,
        coolingSC:0,
        waterSC:0,
      },
      ClassData2:[{ value: 0, name: "其他" }],
      ClassData4:[],
      Classificationloading1:false,
      Classificationloading2:false,
      Classificationloading3:false,
      Classificationloading4:false,
    };
  },
  computed: {
    //最小值
    min() {
      return (key) => {
        let data = this.diagramData.series.filter((e) => {
          return e.name === key;
        });
        if (data.length === 0) {
          return 0;
        }
        let map = data[0].data.filter(e=>e!=null)
        if (
          map.length === 0 ||
          map.filter((e) => e != null).length === 0
        ) {
          return "--";
        }
        let minValue = Math.min(...map);
        let minTimeIndex = map.findIndex((item) => item == minValue);
        let minTime = this.diagramData.xAxis.data[minTimeIndex];
        return (
          floatFormat(Math.min(...map), 2) +
          ` (${this.formateTime(minTime)})`
        );
      };
    },
    //平均值
    average() {
      return (key) => {
        let data = this.diagramData.series.filter((e) => {
          return e.name === key;
        });
        if (data.length === 0) {
          return 0;
        }
        if (
          data[0].data.length === 0 ||
          data[0].data.filter((e) => e != null).length === 0
        ) {
          return "--";
        }
        let sum = 0;
        data[0].data.forEach((e) => (sum += +e));
        return floatFormat(sum / data[0].data.length, 2);
      };
    },
    //最大值
    max() {
      return (key) => {
        let data = this.diagramData.series.filter((e) => {
          return e.name === key;
        });
        if (data.length === 0) {
          return 0;
        }
        let map = data[0].data.filter(e=>e!=null)
        if (
          map.length === 0 ||
          map.filter((e) => e != null).length === 0
        ) {
          return "--";
        }
        let maxValue = Math.max(...map);
        let maxTimeIndex = map.findIndex((item) => item == maxValue);
        let maxTime = this.diagramData.xAxis.data[maxTimeIndex];
        return (
          floatFormat(Math.max(...map), 2) +
          ` (${this.formateTime(maxTime)})`
        );
      };
    },
    nextDayDisabled() {
      let timestamp = dateFormat("YY-mm-dd", new Date());
      let endtime = dateFormat("YY-mm-dd", this.date);
      if (this.radio === "year") {
        timestamp = dateFormat("YY", new Date());
        endtime = dateFormat("YY", this.date);
      } else if (this.radio === "month") {
        timestamp = dateFormat("YY-mm", new Date());
        endtime = dateFormat("YY-mm", this.date);
      } else if (this.radio === "week") {
        timestamp = dateFormat("YY-mm-dd", new Date());
        endtime = dateFormat("YY-mm-dd", addDay(this.date, 5));
      }
      if (endtime >= timestamp) {
        return true;
      } else {
        return false;
      }
    },
    Classification1() {
      return {
        color: ["#0D94FF","#F6BD16", "#E8684A", "#9270CA", "#6DC8EC"],
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return  params.marker +params.name+": " +params.value +"tce"
          }
        },
        series: [
          {
            type: "pie",
            radius: ["35%", "55%"],
            label: {
              formatter: "{name|{b}}\n{time|{d}%}",
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 25,
              fontSize: "16rem",
              fontWeight: 800,
              fontWeight: "bold",
              rich: {
                time: {
                  fontSize: "16rem",
                  color: "#0D94FF",
                  fontWeight: "bold",
                },
                name: {
                  fontSize: "16rem",
                  fontWeight: "bold",
                },
              },
            },
            itemStyle: {
              // 此配置
              normal: {
                borderWidth: 2,
                borderColor: "#ffffff",
              },
            },
            labelLine: {
              show: true,
              lineStyle: {
                width: 2,
              },
            },
            data: [
              { value: this.ClassData1.powerSC?this.ClassData1.powerSC.toFixed(2):0, name: "电" },
              // { value: this.ClassData1.heatSC?this.ClassData1.heatSC.toFixed(2):0, name: "热" },
              // { value: this.ClassData1.coolingSC?this.ClassData1.coolingSC.toFixed(2):0, name: "冷" },
              { value: this.ClassData1.waterSC?this.ClassData1.waterSC.toFixed(2):0, name: "水" },
            ],
          },
        ],
      };
    },
    propsData() {
      return [this.date, this.currentLoop];
    },
    Classification2(){
      return {
        color: ["#0D94FF", "#5EC1FF", "#B0E6FF", "#C3D1D7"],
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return  params.marker +params.name+": " +params.value +"kWh"
          }
        },
        series: [
          {
            type: "pie",
            radius: ["35%", "55%"],
            label: {
              formatter: "{name|{b}}\n{time|{d}%}",
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 25,
              fontSize: "16rem",
              fontWeight: "800",
              rich: {
                time: {
                  fontSize: "16rem",
                  color: "#0D94FF",
                  fontWeight: "800",
                },
                name: {
                  fontSize: "16rem",
                  fontWeight: "bold",
                },
              },
            },
            itemStyle: {
              // 此配置
              normal: {
                borderWidth: 2,
                borderColor: "#ffffff",
              },
            },
            labelLine: {
              show: true,
              lineStyle: {
                width: 2,
              },
            },
            data: this.ClassData2
          },
        ],
      };
    },
    Classification3(){
      return {
      color: ["#5B8FF9"],
      tooltip: {
        trigger: "axis",
        textStyle:{
          align:'left'
        }
      },
      radar: {
        // axisLine: {
        //   show: true,
        // },
        // axisTick:{
        //   show:true,
        // },
        // splitArea:{
        //   show:true,
        // },
        // shape: 'circle',
        indicator: [
          { name: "电", max: this.ClassData1.powerSC>0?this.ClassData1.powerSC*1.5:1000 },
          { name: "冷", max: this.ClassData1.coolingSC>0?this.ClassData1.coolingSC*1.5:1000 },
          { name: "热", max: this.ClassData1.heatSC>0?this.ClassData1.heatSC*1.5:1000 },
          { name: "水", max: this.ClassData1.waterSC>0?this.ClassData1.waterSC*1.5:1000 },
        ],
        radius: 90,
        axisName: {
          color: "#333333",
          fontSize: "16rem",
          fontWeight: "bold",
        },
      },
      series: [
        {
          type: "radar",
          tooltip: {
            trigger: "item",
          },
          areaStyle: {
            color: "rgba(91, 143, 249, 0.5)",
          },
          data: [
            {
              value: [this.ClassData1.powerSC.toFixed(2),
              this.ClassData1.coolingSC.toFixed(2), 
              this.ClassData1.heatSC.toFixed(2), 
              this.ClassData1.waterSC.toFixed(2)],
              name: "分类能耗结构",
            },
          ],
        },
      ],
    };
    },
    Classification4(){
      return {
        color: ["#5B8FF9"],
        tooltip: {
          trigger: "axis",
          textStyle:{
            align:'left'
          }
        },
        radar: {
          indicator: [
            { name: "空调", max: this.ClassData4[0]*1.5 },
            { name: "其他", max: 10000 },
            { name: "动力", max: this.ClassData4[2]*1.5 },
            { name: "照明", max: this.ClassData4[1]>0?this.ClassData4[1]*1.5:1000 },
          ],
          radius: 90,
          axisName: {
            color: "#333333",
            fontSize: "16rem",
            fontWeight: "bold",
          },
        },
        series: [
          {
            type: "radar",
            tooltip: {
              trigger: "item",
            },
            areaStyle: {
              color: "rgba(91, 143, 249, 0.5)",
            },
            data: [
              {
                value: [this.ClassData4[0],0,this.ClassData4[2],this.ClassData4[1]],
                name: "分类能耗结构",
              },
            ],
          },
        ],
      };
    },

  },
  watch: {
    showMax(n, o) {
      this.reload();
    },
    radio(n) {
      this.date = new Date();
    },
    propsData() {
      this.canvasDataRult();
      this.EnergyConsumption();
      this.getBuildingConsumption();
    },
    currentLoop() {
      this.listShow = false;
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closePopover);
  },
  mounted() {
    this.GetreeBuilding();
    document.addEventListener("click", this.closePopover);
  },
  methods: {
    //分类能耗占比
    async getBuildingConsumption() {
       this.Classificationloading1 = true
      let range = this.radio;
      let obj = {
        buildingId: this.currentLoop.id,
        date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
        powerType: "",
        range: range.toUpperCase(),
      };
      let response = await BuildingConsumption(obj)
      let data = response.data.data.result
       this.ClassData1 = data
       this.Classificationloading1 = false
    },
    //分类能耗对比
    async EnergyConsumption() {
       this.Classificationloading2 = true
      let range = this.radio;
      let obj = {
        buildingId: this.currentLoop.id,
        date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
        itemType: "",
        range: range.toUpperCase(),
      };
      let response = await BuildingItemEnergy(obj)
      let data = response.data.data.result
       this.ClassData2 = [{ value: 0, name: "其他" }]
       this.ClassData4 = []
      for (let item in data) {
        this.ClassData2.push({ value: data[item].toFixed(2), name: item })
        this.ClassData4.push(data[item].toFixed(2))
      }
       this.Classificationloading2 = false
    },
    reload() {
      this.canvasShow = !this.canvasShow;
      this.$nextTick(() => {
        this.canvasShow = !this.canvasShow;
      });
    },
    formateTime(string) {
        let array = string.split("");
        array.pop();
        if (array.length < 2) {
          return "0" + array[0] + ":00";
        } else {
          return array.join("") + ":00";
        }
    },
    getcurrentLoop(val) {
      this.currentLoop = val;
    },
    //能耗结构变化趋势
    async canvasDataRult() {
      this.loading = true;
      let range = this.radio;
      let xAxisData = [];
      if (this.radio == "year") {
        for (let i = 1; i <= 12; i++) {
          xAxisData.push(i + "月");
        }
      } else if (this.radio == "month") {
        for (let i = 1; i <= 31; i++) {
          xAxisData.push(i + "日");
        }
      } else if (this.radio == "week") {
        let startDate = weekStart(this.date).replace("T00:00:00Z", "");
        let endDate = weekEnd(this.date).replace("T00:00:00Z", "");
        let time = getDiffDate(startDate, endDate);
        for (let i = 0; i < time.length; i++) {
          xAxisData.push(time[i]);
        }
      } else if (this.radio == "day") {
        for (let i = 0; i < 24; i++) {
          xAxisData.push(i + "点");
        }
      }
      let obj = {
        buildingId: this.currentLoop.id,
        date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
        powerType: "",
        range: range.toUpperCase(),
      };
      let response = await classifiedEnergyConsumptionCoal(obj);
      this.ClassData = response.data.data.result;
      this.canvasShow = true;
      this.$set(
        this,
        "diagramData",
        this.createCanvasData(xAxisData)
      );
    },
    createCanvasData(xAxisData) {
      return  {
        color: ["#F6BD16", "#6DC8EC", "#E8684A", "#9270CA"],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            fontSize: 15,
            fontWeight: 800,
          },
          itemGap: 30,
          data:["电","水","热","冷"]
        },
        grid: {
          left: "1%",
          right: "2%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xAxisData
        },
        yAxis: {
          type: "value",
          name: "折标煤（tce）",
        },
        series: [
          {
            name: "电",
            type: "line",
            smooth: true,
            data: this.ClassData.electricity.map(e=>e==null?null:e.toFixed(2)),
          },
          {
            name: "水",
            type: "line",
            smooth: true,
            data: this.ClassData.water.map(e=>e==null?null:e.toFixed(2)),
          },
          {
            name: "热",
            type: "line",
            smooth: true,
            data: this.ClassData.heat.map(e=>e==null?null:e.toFixed(2)),
          },
          {
            name: "冷",
            type: "line",
            smooth: true,
            data: this.ClassData.cooling.map(e=>e==null?null:e.toFixed(2)),
          },
        ],
      };
    },
    //楼栋
    GetreeBuilding() {
      treeBuilding().then((res) => {
        this.currentLoop = res.data.data.tree[0];
        this.canvasDataRult();
        this.EnergyConsumption();
        this.getBuildingConsumption();
      });
    },
    closePopover(e) {
      let self = this;
      if (self.$refs.area && !self.$refs.area.contains(e.target)) {
        if (self.listShow == true) {
          self.listShow = false;
        }
      }
    },
    closedArea() {
      this.listShow = false;
    },
    perW() {
      let week = getAppointedDate(this.date, 1, 1);
      this.date = new Date(week.startDate);
    },
    nextW() {
      let week = getAppointedDate(this.date, 1, -1);
      this.date = new Date(week.startDate);
    },
    perD() {
      this.date = perDay(this.date);
    },
    nextD() {
      this.date = nextDay(this.date);
    },
    perM() {
      this.date = perMonth(this.date);
    },
    nextM() {
      this.date = nextMonth(this.date);
    },
    perY() {
      this.date = perYear(this.date);
    },
    nextY() {
      this.date = nextYear(this.date);
    },
  },
};
</script>

<style scoped lang="less">
.showMax {
  div.left {
    .w(1220) !important;
  }
}
.echarts {
  .left {
    width: 100%;
  }

  .max-right {
    .w(282);
    .h(340);
    margin-right: 24rem;

    .row-max {
      width: 100%;
      background-color: rgba(0, 43, 102, 0.02);
      // height: 88px;
      margin-bottom: 5px;

      .details {
        .w(185);
        height: 100%;
        padding: 6px 0;

        span {
          margin-right: 8rem;
          color: rgba(13, 148, 255, 1);
          font-size: 15rem;

          &:first-child {
            color: #333333;
          }
        }
      }

      .max-name {
        height: 100%;
        .w(96);
        font-size: 18rem;
        font-weight: bold;
        color: #333333;
      }
    }
  }
}
.tabs-container {
  display: flex;
  flex-direction: row;
  justify-content: space-left;
  height: 4.5vh;
  span {
    line-height: 60rem;
    border-top: 2px solid #fff;
    font-size: 18rem;
    font-weight: 400;
    margin: 0 10rem;
    cursor: pointer;
    font-weight: bold;
  }
  .active {
    color: #0d94ff;
    border-top: 2px solid #0d94ff;
  }
}
.Comparison {
  height: 100%;
  font-size: 18rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: #F5F7F9;
}
.title {
  background: #ffffff;
  height: 8vh;
  padding: 0 30rem;
  width: 100%;
  .demonstration {
    margin-right: 10rem;
  }
  .block {
    margin-right: 80rem;
  }
  .dateSelect {
    margin-right: 10rem;
  }
  .per {
    margin-left: 10rem;
  }
  .el-radio {
    margin-right: 20rem;
  }
  .area {
    height: 3.5vh;
    width: 15vw;
    line-height: 3.5vh;
    background: #eeeeee;
    border-radius: 18rem;
    padding: 0 20rem;
    display: inline-block;
    margin: 0 10rem;
    cursor: pointer;
    img {
      float: right;
      margin-top: 1vh;
    }
  }
}
.cont {
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .box {
    height: 49%;
    background: #fff;
    padding-bottom: 20rem;
    width: 100%;
    padding: 30rem;
    .item {
      width: 20.4vw;
      background: #fff;
      height: 100%;
      text-align: center;
      padding-top: 30rem;
      .top {
        background: rgba(0, 43, 102, 0.06);
        border-radius: 18rem;
        font-size: 16px;
        color: #002b66;
        display: inline-block;
        text-align: center;
        width: 10vw;
        line-height: 3.5vh;
        margin-bottom: 2.5vh;
      }
    }
  }
  .tt {
    font-size: 18rem;
    font-weight: bold;
  }
}
</style>
